/*
 * @Descripttion: 收银设备
 * @version: 1.0.0
 * @Author: ck
 * @Date: 2019-10-15 15:45:24
 * @LastEditors: ck
 * @LastEditTime: 2019-10-16 15:10:29
 */

const _load = require('@/routers/_loadPath/_load_' + process.env.NODE_ENV)
let POS = _load('product/facility/pos/POS')
let selfServiceCashier = _load('product/facility/selfServiceCashier/Index')
let massageArmchair = _load('product/facility/massageArmchair/Index')
let scanCode = _load('product/facility/scanCode/Index')
let loudspeakerBox = _load('product/facility/loudspeakerBox/Index')
let receivingCode = _load('product/facility/receivingCode/Index')
const routes = [{
    path: 'facility/pos',
    component: POS,
    name: 'pos',
    meta: {
      title: '传贝收银机'
    },
  },
  {
    path: 'facility/selfServiceCashier',
    component: selfServiceCashier,
    name: 'selfServiceCashier',
    meta: {
      title: '传贝自助收银台'
    },
  },
  {
    path: 'facility/massageArmchair',
    component: massageArmchair,
    name: 'massageArmchair',
    meta: {
      title: '传贝按摩椅'
    },
  },
  {
    path: 'facility/scanCode',
    component: scanCode,
    name: 'scanCode',
    meta: {
      title: '传贝扫码王'
    },
  },
  {
    path: 'facility/loudspeakerBox',
    component: loudspeakerBox,
    name: 'loudspeakerBox',
    meta: {
      title: '传贝收款音响'
    },
  },
  {
    path: 'facility/receivingCode',
    component: receivingCode,
    name: 'receivingCode',
    meta: {
      title: '传贝收款码'
    },
  },
];

export default routes